define([], function () {
    /** methods and properties shared across more than one tool **/
    var uShared = (function (win) {

        var uShared = {

            // pseudo-constants
            META_ACTION: 'Action',
            META_SECTION: 'Section',
            META_ERROR: 'Error',

            _version: 'uDash JS 3.2.21', // app version

            // app status
            // notready  - no handlers have been attached and no storage data has been set
            // setup - during attachment of handlers and setting storage data
            // ready - all handlers attached and storage data set, ready to record, not connected yet
            // connected - connected to UiB server, up & running
            // teardown - during the process of tearing down
            _status: ['notready', 'setup', 'ready', 'connected', 'teardown'][0],
            _heatmapstatus: ['notready', 'setup', 'ready', 'connected', 'teardown'][0],
            _defaults: {

                _assetsPath: 'https://uibcdn.com/html_includes/',
                _apiUrl: 'http://api.useitbetter.com/',
                _apiUrlSSL: 'https://apigl.useitbetter.com/',
                _panelPath: 'https://app.useitbetter.com/',

                uDumpProtocole: 'https:',
                cdnDomain: 'uibcdn.com',
                uDumpDomain: 'l.useitbetter.com',
                uDumpMethod: 'pushFileAppendData.php',

                uProjectName: '',
                uPort: '',
                uProjectApiPass: '',

                uAllowCookies: true,
                uAllowTriggerCookies: true,
                uAllowTracking: true,
                uForceTracking: 0,
                uRecordInteractiveEvents: true,
                uRecordFormSubmit: true,
                uRecordHashChange: true,
                uRecordParamsChange: false,
                uRecordUrlChange: true,
                uRecordPageChanges: false,
                uRecordPageChangesAfterEvent: 'click',
                uRecordCookies: false,
                maskTagContentSelectors: ['[udash-mask-content="1"]'],
                /*maskTagAttributeSelectors: ['[udash-mask-attributes="value"]'],*/
                uIncludeHostnameInSection: false,
                uCompressDump: false,
                uRecordFrames: false,
                uRecordPointerChange: 200,
                uIgnoreEvents: {},
                uFullElementBacktrace: false,
                uIgnoreClassNamesWithPrefix: ['ng-', 'box-'],
                uIgnoreIdsWithPrefix: ['tui_', 'p20'],
                uIgnoreTailwindClasses: false,
                uPackageLimit: 40,
                uSendTimeout: 5,
                uShowConsoleMessages: false,
                uShowEventsTraceInConsole: false,
                uSample: 0,
                uTrackingMode: 'SESSIONS',
                uUseDefaultPanelOpener: false,
                uEmptySendLimit: 300,
                uKeepConnection: false,
                uRecordAjax: false,
                uCrossSiteSessionsEnabled: true,
                uCrossSiteSameDomain: true,
                uTriggersEnabled: true,
                uTriggersMarking: false,
                uTriggersTimeout: 5000,
                uTriggersCheckInterval: 150,
                uAllowTriggersInNotRecordedSessions: true,
                uDotSize: 28,
                uHeatMapOpacity: 190,
                uHeatMapGradient: { // color palette gradient
                    0.05: '#35267b',
                    0.10: '#3f1e7b',
                    0.15: '#49087f',
                    0.20: '#5c0872',
                    0.25: '#78085d',
                    0.30: '#91084c',
                    0.35: '#a7083c',
                    0.40: '#b8082f',
                    0.45: '#ca0822',
                    0.50: '#d61119',
                    0.55: '#d73319',
                    0.60: '#d75919',
                    0.65: '#d78219',
                    0.70: '#d7a919',
                    0.75: '#d7ba1a',
                    0.80: '#d7cc1c',
                    0.85: '#d7d446',
                    0.90: '#d7d479',
                    0.95: '#d7d4ae',
                    1: '#d7d4e5'
                },
                uHeatMapStyles: {}, // styles that will be set on canvas element

                uAjaxCacheFlag: 'cacheFromUser',
                uSkipTimeThreshold: 7,

                uWrapperSelector: '',

                // callbacks
                onReady: function () {},
                onConnected: function () {},
                onTeardown: function () {},
                onDumpSend: function () {}
            },

            // temporary cache for cookies and analytics data
            _unsavedCookies: {},
            _unsentEvents: [],

            // number determining how many times uDash should reattempt ajax request in case of failure
            _failedRequestRetry: 20,

            // number of failed ajax requests
            _failedRequests: 0,

            // number of failed setup attempts
            _failedSetups: 0,

            _isIE9: win.navigator.userAgent.indexOf('MSIE 9') > -1, // temporary browser sniff, upgrade to feature detection later

            _isIE9Mobile: win.navigator.userAgent.indexOf('MSIE 9') > 1 && win.navigator.userAgent.indexOf('Mobile') > 1,

            _isTouchSupported: 'ontouchstart' in win,

            _recordsSeparator: '\n', // what character is used to separate records 

            _lstorage: {}, // localStorage wrapper, initialized after definition

            _sstorage: {}, // sessionStorage wrapper, initialized after definition 

            _winEventListenerCapture: {}, // spy for all event listeners set on window

            _docEventListenerCapture: {}, // spy for all event listeners set on document

            _htmlEventListenerCapture: {}, // spy for all event listeners set on any HTML element

            // Storage wrapper constructor for namespacing storage data as uDash.*
            _UStorage: (function () {

                var UStorage = function (storageObject) {
                    this.temp = {};
                    this.storageObject = storageObject;
                    for (var item in storageObject) {
                        if (item.indexOf('uDash.') === 0) {
                            this.temp[item.substr(6)] = storageObject.getItem(item);
                        }
                    }
                };

                UStorage.prototype = {

                    set: function (name, value) {
                        var uAllowCookies = win.uDash.getSetting('uAllowCookies');
                        if (!uAllowCookies) {
                            this.temp[name] = value;
                            return;
                        }else{
                            delete this.temp[name];
                        }
                        var obj,
                            loopName;

                        if (typeof name === 'object') {
                            obj = name;
                            for (loopName in obj) {
                                if (obj.hasOwnProperty(loopName)) {
                                    this.set(loopName, obj[loopName]);
                                }
                            }
                        } else {
                            if (name.match(/^uDash\./)) {
                                name = name.replace('uDash.', '');
                            }
                            return this.storageObject.setItem('uDash.' + name, value);
                        }
                    },

                    get: function (name) {
                        return this.temp[name] || this.storageObject.getItem('uDash.' + name);
                    },

                    remove: function (name) {
                        if (!win.uDash.getSetting('uAllowCookies')) {
                            delete this.temp[name];
                            return;
                        }
                        return this.storageObject.removeItem('uDash.' + name);
                    },

                    enable: function () {
                        for (var name in this.temp) {
                            this.set(name, this.temp[name]);
                            delete this.temp[name];
                        }
                    },



                    // make backup copy of the storage and put it into window.name property
                    // that property behaves somewhat like a sessionStorage but without url restraints,
                    // so by setting data on it we're able to record sessions based on initialization data (project, port, password)
                    // and not be tied to a particular address (not even a domain, like in case of cookies)
                    makeBackup: function (projectName, projectPort, projectApiPass) {
                        if (win.uDash._globalSettings && !win.uDash._globalSettings.uAllowCookies) {
                            return;
                        }
                        if (win.uDash._globalSettings && !win.uDash._globalSettings.uCrossSiteSessionsEnabled) {
                            uShared._uConsole.log('uRecorder: cross-site/domain tracking disabled');
                            return;
                        }
                        try {
                            var /*name,*/
                                values = {},
                                arr = [],
                                leftSide = '',
                                rightSide = '',
                                backupString = '',
                                replaceString = '@#@';




                            values['userID'] = win.localStorage.getItem('uDash.userID');

                            if (!values['userID']) return;

                            values['userVisit'] = win.localStorage.getItem('uDash.userVisit');

                            // this is stored in cookies, but won't work if top domain changes
                            if (!win.uDash._globalSettings.uCrossSiteSameDomain) {
                                values['uDashIn'] = win.localStorage.getItem('uDash.in');
                                values['uDashOut'] = win.localStorage.getItem('uDash.out');
                            }

                            // continue recording to same session 
                            if (win.udashSessionToken) values['logDumpToken'] = win.udashSessionToken;
                            values['timeOffset'] = win.sessionStorage.getItem('uDash.timeOffset');

                            // stay in live/preview mode 
                            var debug = win.sessionStorage.getItem('uDash.uDebug');
                            if (debug) values['uDebug'] = debug;

                            arr = win.name.split('%p%' + projectApiPass + '%p%');

                            /*for (name in this.storageObject) {
                                if (name.match(/^uDash\./)) {
                                    // skip larger variables to avoid window.name overload.
                                    switch (name) {
                                    case 'uDash.dump':
                                    case 'uDash.tempDump':
                                    case 'uDash.path':
                                    case 'uDash.triggers':
                                        break;
                                    default:
                                        values[name] = this.storageObject.getItem(name);
                                    }
                                }
                            }*/

                            if (arr.length > 1) {
                                leftSide = arr[0] + '%p%' + projectApiPass + '%p%';
                                rightSide = arr[1].substr(arr[1].indexOf('%e%'), arr[1].length - 1);
                                backupString = leftSide + replaceString + rightSide;
                            } else {
                                backupString += '%s%' + [projectName, projectPort, projectApiPass, replaceString].join('%p%') + '%e%';
                            }

                            win.name = backupString.replace(replaceString, JSON.stringify(values));

                        } catch (e) {
                            uShared._uConsole.log('uRecorder: backup failed with error:', e);
                        }
                    },

                    // restoring backup, if backup is found it is deleted before returning
                    getBackup: function (projectName, projectPort, projectApiPass) {
                        var backupParts,
                            backupObj,
                            match = win.name.match(/\%s\%.+\%e\%/),
                            i,
                            isFromCookie = false;
                        try {
                            if (!match) {
                                var backupCookie = uShared._readCookie('uDashBackup');
                                if (backupCookie) match = unescape(backupCookie).match(/\%s\%.+\%e\%/);

                                if (!match) {
                                    match = [];
                                } else {
                                    isFromCookie = true;
                                }
                            }

                            // notice: there can be multiple projects data stored in one session, we don't want them to collide
                            for (i = 0; i < match.length; i++) {

                                backupParts = (match[i].split('%s%')[1].split('%e%')[0]).split('%p%');
                                if (
                                    backupParts.length === 4 && backupParts[0] === projectName
                                ) {

                                    backupObj = JSON.parse(backupParts[3]);
                                    if (isFromCookie) {
                                        if (backupObj['uDash.currentUrl'] && uShared._domainChanged(win.location.href, backupObj['uDash.currentUrl'])) {
                                            //console.log('uRecorder: Backup retrieved from cookie',backupObj);                                                    
                                        } else {
                                            //console.log('uRecorder: Domain did not change, ignore backup from cookie',win.location.href,backupObj['uDash.currentUrl']);
                                            return false;
                                        }
                                    }
                                    return backupObj;

                                }
                            }
                        } catch (e) {
                            if (typeof uDash !== 'undefined' && uDash.saveMeta) uDash.saveMeta('recording alert', 'could not read backup');
                            setTimeout(function () {
                                if (typeof uDash !== 'undefined' && uDash.saveMeta) uDash.saveMeta('recording alert', 'could not read backup')
                            }, 3000);

                            backupObj = {};
                            return false;
                        }
                        return false;

                    },

                    clear: function (options) {
                        options = options || {};

                        var name;
                        for (name in this.temp) {
                            delete this.temp[name];
                        }
                        for (name in this.storageObject) {
                            if (name.match(/^uDash\./)) {
                                if (!options.except || options.except.indexOf(name.replace('uDash.', '')) === -1) {
                                    this.storageObject.removeItem(name);
                                }
                            }
                        }
                    }
                };

                return UStorage;

            }()),

            // spy that watches event listeners being set or removed on given element or object
            _UEventListenerCapture: (function () {

                // private, all the event listeners set on watched elements and objects 
                var _allEvents = {

                    registered: [],

                    add: function (target, name, handler, useCapture) {
                        this.registered.push({
                            target: target,
                            name: name,
                            handler: handler,
                            useCapture: useCapture
                        });
                    },

                    remove: function (target, name, handler) {

                        var i;

                        for (i = 0; i < this.registered.length; i++) {
                            if (
                                this.registered[i].target === target &&
                                this.registered[i].name === name &&
                                this.registered[i].handler === handler
                            ) {
                                this.registered.splice(i, 1);

                                return i;
                            }
                        }

                        return -1;

                    }

                };

                //	constructor method for objects that serve as a public interface for spyed objects and elements
                var _UEventListenerCapture = function (target) {

                    this.target = target;
                    this.augmentTarget = (typeof target.prototype !== 'undefined' && typeof target.prototype.addEventListener !== 'undefined') ? target.prototype : target;

                    // augmentation of original addEventListener, adding one extra parameter - if set to true, listener is not registered in _allEvents object
                    (function (obj, addEventListener) {

                        obj.addEventListener = function (name, handler, useCapture, ignore) {

                            if (!ignore) {
                                _allEvents.add(this, name, handler, useCapture);
                            }

                            // pass into original addEventListener
                            return addEventListener.call(this, name, handler, useCapture);
                        };

                    }(this.augmentTarget, this.augmentTarget.addEventListener));


                    // augmentation of original removeEventListener, adding one extra parameter - if set to true, listener is not removed from _allEvents object
                    (function (obj, removeEventListener) {

                        obj.removeEventListener = function (name, handler, ignore) {

                            if (!ignore) {
                                _allEvents.remove(this, name, handler);
                            }

                            // pass into original addEventListener
                            return removeEventListener.call(this, name, handler);

                        };


                    }(this.augmentTarget, this.augmentTarget.removeEventListener));

                };

                _UEventListenerCapture.prototype = {

                    // add all captured listeners for a observed element	
                    addAll: function (name) {

                        var i;

                        for (i = 0; i < _allEvents.registered.length; i++) {

                            if (
                                (typeof this.target === 'object' && _allEvents.registered[i].target === this.target) ||
                                (typeof this.target === 'function' && _allEvents.registered[i].target instanceof this.target)
                            ) {
                                this.target.addEventListener(
                                    _allEvents.registered[i].name,
                                    _allEvents.registered[i].handler,
                                    _allEvents.registered[i].useCapture,
                                    true
                                );
                            }
                        }

                    },

                    // remove all captured listeners from observed element
                    removeAll: function () {

                        var i;

                        for (i = 0; i < _allEvents.registered.length; i++) {
                            if (
                                (typeof this.target === 'object' && _allEvents.registered[i].target === this.target) ||
                                (typeof this.target === 'function' && _allEvents.registered[i].target instanceof this.target)
                            ) {
                                this.target.removeEventListener(
                                    _allEvents.registered[i].name,
                                    _allEvents.registered[i].handler,
                                    true
                                );
                            }
                        }

                    }
                };

                return _UEventListenerCapture;

            }()),

            _apiManager: {

                apiHost: '',
                apiHostSSL: '',
                apiProjectAuthKey: '',
                apiAccountAuthKey: '',
                projectHash: '',

                getApiUrl: function () {

                    var isHttps = (win.location.protocol === 'https:'),
                        uApiUrl = uShared._sstorage.get('uApiUrl');

                    if (uApiUrl) {
                        return uApiUrl;
                    } else if (isHttps) {
                        return this.apiHostSSL || uShared._defaults._apiUrlSSL;
                    } else {
                        return this.apiHost || uShared._defaults._apiUrl;
                    }
                },

                cache: {
                    data: {},

                    createIndex: function () {
                        return JSON.stringify(Array.prototype.slice.call(arguments));
                    },

                    storeObject: function () {
                        var args = Array.prototype.slice.call(arguments),
                            data = args.shift(),
                            index = this.createIndex.apply(this, args);

                        this.data[index] = data;

                    },

                    getObject: function () {
                        var index = this.createIndex.apply(this, Array.prototype.slice.call(arguments));
                        if (this.data.hasOwnProperty(index)) {
                            return this.data[index];
                        } else {
                            return false;
                        }
                    }

                },

                send: function (options) {

                    var that = this,
                        data = options.data || {},
                        cacheObject;



                    if (typeof options.method !== 'string') {
                        uShared._uConsole.error('API: Specify api call method');
                    }

                    if (this.apiAccountAuthKey && [this.ACCOUNT_PROJECT_LOGIN, this.ACCOUNT_PROJECT_LIST].indexOf(options.method) > -1) {
                        data.apiAccountAuthKey = this.apiAccountAuthKey;
                    } else if (this.apiProjectAuthKey && options.method !== this.ACCOUNT_LOGIN) {
                        data.apiAuthKey = this.apiProjectAuthKey;
                    }
                    data.getRequest = 1;

                    cacheObject = this.cache.getObject(options, data);

                    if ((options.cache && options.cache === false) || !cacheObject) {

                        return uShared._ajax({
                            url: that.getApiUrl() + options.method,
                            method: 'POST',
                            data: data,
                            success: function (response) {
                                try {
                                    response = JSON.parse(response);
                                    that.cache.storeObject(response, options, data);
                                } catch (e) {
                                    response = {};
                                }

                                return options.success(response);
                            }
                        });
                    } else if (cacheObject) {
                        return options.success(cacheObject);
                    }
                }

            },

            // shortener/expander of property names in Events, used to reduce amount of data pushed through wire
            _propertyNames: {

                _map: {
                    kC: 'keyCode',
                    cX: 'clientX',
                    cY: 'clientY',
                    pX: 'pageX',
                    pY: 'pageY',
                    sX: 'screenX',
                    sY: 'screenY',
                    id: 'identifier',
                    t: 'touches',
                    tT: 'targetTouches',
                    cT: 'changedTouches'
                    /*,
                    							chk: 'checkTag'*/
                },

                _iterator: function (obj, getter) {
                    var name,
                        i,
                        mapName,
                        newObj;

                    if (Array.isArray(obj)) {
                        newObj = [];
                        for (i = 0; i < obj.length; i++) {
                            if (typeof obj[i] === 'object') {
                                newObj[i] = this._iterator(obj[i], getter);
                            } else {
                                newObj[i] = obj[i];
                            }
                        }
                    } else {
                        newObj = {};
                        for (name in obj) {
                            if (obj.hasOwnProperty(name)) {
                                mapName = getter(name);

                                if (typeof obj[name] === 'object') {
                                    newObj[mapName] = this._iterator(obj[name], getter);
                                } else {
                                    newObj[mapName] = obj[name];
                                }
                            }
                        }
                    }

                    return newObj;

                },

                getShortName: function (name) {
                    var mapName;
                    for (mapName in this._map) {
                        if (this._map.hasOwnProperty(mapName) && this._map[mapName] === name) {
                            return mapName;
                        }
                    }
                    return name;
                },

                getLongName: function (name) {
                    return this._map[name] || name;
                },

                shorten: function (obj) {

                    return this._iterator(obj, uShared._bindShim(this.getShortName, this));

                },

                expand: function (obj) {

                    return this._iterator(obj, uShared._bindShim(this.getLongName, this));

                }
            },

            // little shim for Function.prototype.bind (due to older android 2.3 browser's implementation problems - drop it when system becomes outdated)
            _bindShim: function () {

                var args = Array.prototype.slice.call(arguments),
                    func = args.shift(),
                    ctx = args.shift();

                return function () {
                    return func.apply(ctx, arguments);
                };
            },

            _selectorMatch: function (selectorString, element, parent) {

                if (!parent) {
                    parent = win.document;
                }

                var i,
                    check = parent.querySelectorAll(selectorString);

                for (i = 0; i < check.length; i++) {
                    if (check[i] === element) {
                        return true;
                    }
                }

                return false;

            },

            // deep extension of one object by another
            _extend: function () {

                var args = Array.prototype.slice.call(arguments),
                    base = args.shift(),
                    extend,
                    prop,
                    i;

                for (i = 0; i < args.length; i++) {

                    extend = args[i];

                    for (prop in extend) {
                        if (extend.hasOwnProperty(prop)) {
                            if (typeof extend[prop] === 'object' && !Array.isArray(extend[prop])) {

                                if (base.hasOwnProperty(prop)) {
                                    base[prop] = uShared._extend(base[prop], extend[prop]);
                                } else {
                                    base[prop] = uShared._extend({}, extend[prop]);
                                }
                            } else {
                                try {
                                    base[prop] = extend[prop];
                                } catch (e) {}
                            }
                        }
                    }
                }

                return base;

            },

            // getter for application status
            getStatus: function () {
                return this._status;
            },

            disableCookies: function () {
                win.uDash._globalSettings.uAllowCookies = false;
                uShared._clearCookie('uDashIn');
                uShared._clearCookie('uDashOut');
                uShared._sstorage.clear();
                uShared._lstorage.clear();
                return true;
            },
            enableCookies: function () {
                if (!win.uDash._globalSettings.uAllowCookies) {
                    win.uDash.setSetting('uAllowCookies',true);
                    for (var name in win.uDash.shared._unsavedCookies) {
                        var c = win.uDash.shared._unsavedCookies[name];
                        uShared._setCookie(c.name, c.value, c.expires);
                    }
                    win.uDash.shared._unsavedCookies = {};
                    uShared._sstorage.enable();
                    uShared._lstorage.enable();
                }
                return true;
            },

            enableTracking: function () {
                if (!win.uDash._globalSettings.uAllowTracking) {
                    /*
                    if ( !win.uDash._globalSettings.uAllowCookies ) {
                        uShared._uConsole.log('uRecorder: cookies must be enabled to enable tracking');
                        return false;
                    }
                    */
                    win.uDash._globalSettings.uAllowTracking = true;
                    win.uDash.connect();
                }
                return true;
            },

            // attachment of event handlers in useCapture mode
            // win_* - handlers attached on window
            // doc_* - handlers attached on window.document
            _attachEventHandlers: function (handlers, settings, customTarget) {
                var i, handlerTarget, handlerName;

                for (i in handlers) {

                    if (settings.uIgnoreEvents[i.substr(4)]) {
                        continue;
                    }
                    /*if (window.location.pathname.indexOf('checkout3')>-1 && i.indexOf('touch')>-1){
                        continue;
                    }*/
                    if (handlers.hasOwnProperty(i)) {
                        if (!customTarget) {
                            if (i.match(/^doc\_/)) {
                                handlerTarget = win.document;
                                handlerName = i.replace('doc_', '');
                            } else if (i.match(/^win\_/)) {
                                handlerTarget = win;
                                handlerName = i.replace('win_', '');
                            } else {
                                handlerTarget = null;
                            }
                            if (handlerTarget) {
                                handlerTarget.addEventListener(handlerName, handlers[i], true);
                            }
                        } else {
                            if (i.match(/^doc\_/)) {
                                handlerName = i.replace('doc_', '');
                                customTarget.addEventListener(handlerName, handlers[i], true);
                            }
                        }

                    }
                }
            },

            // detachment of event handlers
            _detachEventHandlers: function (handlers) {

                var i, handlerTarget, handlerName;

                for (i in handlers) {
                    if (handlers.hasOwnProperty(i)) {
                        if (i.match(/^doc\_/)) {
                            handlerTarget = win.document;
                            handlerName = i.replace('doc_', '');
                        } else if (i.match(/^win\_/)) {
                            handlerTarget = win;
                            handlerName = i.replace('win_', '');
                        } else {
                            handlerTarget = null;
                        }

                        if (handlerTarget) {
                            handlerTarget.removeEventListener(handlerName, handlers[i]);
                        }
                    }
                }
            },

            // convenience method for getting document's width and height
            _getDocumentSize: function () {
                return {
                    width: win.document.documentElement.scrollWidth,
                    height: win.document.documentElement.scrollHeight
                };
            },

            // get viewport size
            _getWindowSize: function () {
                return {
                    width: win.document.documentElement.clientWidth,
                    height: win.document.documentElement.clientHeight
                };
            },

            // get scroll offset of the document
            _getScroll: function () {
                var doc = win.document.documentElement,
                    body = win.document.body;

                return {
                    x: doc && doc.scrollLeft || body && body.scrollLeft || 0,
                    y: doc && doc.scrollTop || body && body.scrollTop || 0
                };
            },

            // get document scale information
            _getDocumentScale: function () {
                var viewportScale = undefined,
                    screenWidth = win.innerWidth;

                if (win.orientation) {
                    screenWidth = screen.width; //eq. with window.screen
                    if (win.orientation === 'portrait') {
                        if (screen.width > screen.height) {
                            screenWidth = screen.height;
                        }
                    } else {
                        if (screen.width < screen.height) {
                            screenWidth = screen.height;
                        }
                    }
                    viewportScale = screenWidth / win.innerWidth;
                } else {
                    viewportScale = 1; // always 1 for desktop            
                }

                return viewportScale;
            },

            // console self-overwriting wrapper
            _uConsole: {
                init: function (showMessages) {
                    if (win.console && showMessages) {
                        uShared._uConsole = win.console;
                    } else {
                        uShared._uConsole = {
                            log: function () {},
                            error: function () {},
                            warn: function () {}
                        };
                    }
                }
            },

            // timeouts wrapper, used to keep track of timeouts and conveniently clear all of them during teardown
            _timeouts: {

                current: {},

                // set timeout
                set: function (name, func, delay) {
                    var that = this,
                        altName = name,
                        i = 0;

                    // if there already is a timeout with that name, search for next free name
                    if (typeof this.current[name] === 'number') {
                        do {
                            altName = name + '.' + i;
                            i += 1;
                        } while (typeof this.current[altName] === 'number');
                        name = altName;
                    }

                    this.current[name] = win.setTimeout(function () {
                        that.clear(name);
                        func();
                    }, delay);
                },

                // clear timeout
                clear: function (name) {
                    if (typeof this.current[name] === 'number') {
                        win.clearTimeout(this.current[name]);
                        delete this.current[name];
                    }
                },

                // clear all timeouts
                clearAll: function () {
                    var name;
                    for (name in this.current) {
                        if (this.current.hasOwnProperty(name)) {
                            this.clear(name);
                        }
                    }
                }
            },

            // dynamic css loader
            _loadCss: function (file, assetsPath) {
                var body = win.document.querySelector('body'),
                    stylesheet;

                if (win.document.createStyleSheet) { // IE model
                    stylesheet = win.document.createElement('style');

                    // do not use createStyleSheet as it sometimes doesn't work in IE mobile, use ajax instead
                    this._ajax({
                        method: 'GET',
                        url: assetsPath + 'getCrossdomain.php?uStylesheetFile=' + file,
                        success: function (response) {
                            stylesheet.appendChild(win.document.createTextNode(response));
                            body.appendChild(stylesheet);
                        }
                    });
                } else { // standard model
                    stylesheet = win.document.createElement('link');
                    stylesheet.setAttribute('rel', 'stylesheet');
                    stylesheet.setAttribute('href', assetsPath + file);
                    body.appendChild(stylesheet);
                }

            },

            // automatic page wrap element finder, used for heatmaps
            _wrapFinder: {

                _wrapper: null,
                _levelLimit: 5, // how many levels deep should wrapper be looked for
                _levelRating: [-3, 0, -1, -1, -2, -2, -3, -3], // amount of rating score each level decreases
                _candidates: [],
                _compareWidth: 0,
                _words: [
       /wrap/i,
       /contain/i,
       /conten/i
      ],

                // size of the body element
                // if body overflow-x (horizontal scroll) is hidden use clientWidth, otherwise use scrollWidth
                _getCompareWidth: function () {

                    var htmlStyle = win.getComputedStyle(win.document.documentElement),
                        bodyStyle = win.getComputedStyle(win.document.body);

                    if (
                        htmlStyle.overflow === 'hidden' || bodyStyle.overflow === 'hidden' ||
                        htmlStyle.overflowX === 'hidden' || bodyStyle.overflowX === 'hidden'
                    ) {
                        return win.document.body.clientWidth;
                    } else {
                        return win.document.body.scrollWidth;
                    }
                },

                find: function () {

                    if (!this._wrapper || this._wrapper.getBoundingClientRect().width === 0) {

                        this._compareWidth = this._getCompareWidth();

                        this._buildCandidates(win.document.body, 0); // start building candiates list from <html> element

                        this._candidates.sort(function (a, b) { // sort candidates by rating
                            if (a.rating > b.rating) {
                                return -1;
                            } else if (a.rating < b.rating) {
                                return 1;
                            } else {
                                return 0;
                            }
                        });
                        this._wrapper = this._candidates[0].element;
                    }

                    return this._wrapper;
                },

                _rateElement: function (element, level) {
                    
                    if (!element.querySelector('h1')) return 0;

                    var rating = 0,
                        winSize = uShared._getWindowSize(),
                        offsetLeft = Math.ceil(element.getBoundingClientRect().left + uShared._getScroll().x),
                        i;


                    if (
                        (element.clientWidth < this._compareWidth && element.clientWidth > this._compareWidth / 2) || // element is smaller than whole document, but larger than half of the document
                        (element.clientWidth > winSize.width) // or element is larger than viewport
                    ) {
                        rating += 10;
                    }
                    // element is centered
                    if (
                        offsetLeft === Math.ceil((this._compareWidth - element.clientWidth) / 2) ||
                        offsetLeft === Math.ceil((this._compareWidth - element.clientWidth) / 2) - 1
                    ) {
                        rating += 15;
                    }

                    // element is named in a suggestive way
                    for (i = 0; i < this._words.length; i++) {
                        if (element.className && element.className.match && element.className.match(this._words[i])) {
                            rating += 5;
                        }
                        if (element.getAttribute('id') && element.getAttribute('id').match(this._words[i])) {
                            rating += 7;
                        }
                    }

                    rating += this._levelRating[level];

                    return rating;


                },


                _buildCandidates: function (parent, level) { // go down the DOM tree looking for wrapper candidates
                    var children = parent.children,
                        i = 0;

                    if (level < this._levelLimit && children.length > 0) {
                        for (i = 0; i < children.length; i++) {
                            if (children[i].nodeType === 1) {
                                this._candidates.push({
                                    element: children[i],
                                    rating: this._rateElement(children[i], level)
                                });
                                this._buildCandidates(children[i], level + 1);
                            }
                        }
                    }
                },



                // if element is set explicitly via init() options
                setWrapper: function (element) {
                    this._wrapper = element;
                },

                getWrapperOffset: function () {
                    return Math.floor(this.find().getBoundingClientRect().left + uShared._getScroll().x);
                }

            },

            // store uParams from URL into an object
            _uParams: {

                _keysToPreserve: ['apiAuthKey'], // which keys should not be flushed during session storage clear

                loadFromUrl: function () {

                    var paramsLocation,
                        paramsString = '',
                        paramsSplit = {},
                        oneParamSplit = {},
                        i;

                    if (win.location.search.indexOf('uParams') > -1) {
                        paramsLocation = win.location.search;
                    } else if (win.location.hash.indexOf('uParams') > -1) {
                        paramsLocation = win.location.hash;
                    }

                    if (paramsLocation) {

                        uShared._sstorage.clear({
                            except: this._keysToPreserve
                        });

                        paramsString = decodeURIComponent(decodeURI(paramsLocation)).split('uParams=')[1].split('&')[0];
                        paramsSplit = paramsString.split('||');

                        for (i = 0; i < paramsSplit.length; i++) {
                            oneParamSplit = paramsSplit[i].split('@@');
                            uShared._sstorage.set(oneParamSplit[0], oneParamSplit[1]);
                        }
                        return true;
                    } else {
                        return false;
                    }
                },

                // method used to remove uParams string from the url (used for generating heatmaps and replays from url meta sections)
                stripFromUrl: function (url) {

                    url = url.replace(/uParams=[a-zA-Z0-9@%\/]+/, '');

                    if (url.indexOf('?#') > -1) { // if uParams were only GET params, remove question mark
                        url = url.replace('?#', '#');
                    }

                    if (url.indexOf('?') === url.length - 1) {
                        url = url.slice(0, url.length - 1);
                    }

                    if (url !== url) {
                        var lastChar = url.substr(-1);
                        if (lastChar === '?' || lastChar === '#') url = url.substr(0, url.length - 1);
                    }

                    return url;
                },

                loadFromJSON: function (obj) {

                    if (!obj.toString || obj.toString() !== '[object Object]') {
                        try {
                            obj = JSON.parse(obj);
                        } catch (e) {
                            obj = {};
                        }
                    }

                    uShared._sstorage.clear({
                        except: this._keysToPreserve
                    });


                    uShared._sstorage.set(obj);

                },

                stringFromObject: function (obj) {

                    var name,
                        params = [];

                    for (name in obj) {
                        params.push(name + '@@' + obj[name]);
                    }

                    return params.join('||');

                }
            },

            _getMetaSectionAutosaveName: function (settings) {

                var base = settings.uIncludeHostnameInSection ? win.location.hostname + win.location.pathname : win.location.pathname,
                    search = win.location.search,
                    hash = win.location.hash,
                    toSave = '';

                if (base[0] === '/') {
                    base = base.substr(1);
                }
                if (base === '') {
                    base = 'Home';
                }

                if (settings.uRecordUrlChange) {
                    toSave = base;
                }

                // custom code
                //toSave=toSave.split(';jsessionid')[0]; 
                // end of custom code

                if (settings.uRecordParamsChange && search) {
                    toSave = base + search;
                }
                if (settings.uRecordHashChange) {
                    toSave += hash;
                }

                if (toSave) {
                    var section = uShared._prepareUrl(decodeURIComponent(toSave));
                    //var lastSection = uShared._sstorage.get('lastSection')  || '';;
                    // custom code


                    // end of custom code
                    toSave = section;
                }

                if (!settings.uRecordExecutionFlow) {
                    toSave = toSave.replace(/e+[0-9]+s+[0-9]+/, '');
                }

                var params = toSave.split('uParams');
                if (params[1]) {
                    toSave = params[0];
                    if (params[1].indexOf('&') > -1) {
                        toSave += params[1].substr(params[1].indexOf('&') + 1, params[1].length);
                    }
                }

                if (toSave /*&& lastSection !== toSave*/ ) {
                    return toSave;
                } else {
                    return '';
                }
            },


            // url cleaner
            _prepareUrl: function (url) {
                if (url.indexOf('#') === url.length - 1) { // there is a trailing hash, remove it
                    url = url.slice(0, url.length - 1);
                }

                return url;
            },

            _encodePOST: function (data) {
                var name,
                    value,
                    encodedData = [];

                for (name in data) {
                    if (data.hasOwnProperty(name)) {
                        value = (data[name] || '').toString();
                        value = encodeURIComponent(value).replace('%20', '+');
                        name = encodeURIComponent(name).replace('%20', '+');
                        encodedData.push(name + '=' + value);
                    }
                }

                return encodedData.join('&');
            },

            // generic method for sending data (cross-domain ajax)
            _ajax: function (options) {

                var xhr,
                    success = options.success || function () {},
                    error = options.error || function () {},
                    data = options.data || {},
                    url = options.url,
                    method = options.method || 'POST',
                    encodedData = '',

                    retryOnError = function () { // retry connection on error
                        if (uShared.getStatus() !== 'teardown') {
                            uShared._failedRequests++;
                            error(xhr);
                        }
                        /*
                        if (uShared.getStatus() !== 'teardown') { // error occurred, but uDash is not being torn down
                            if (uShared._failedRequests < uShared._failedRequestRetry) { // there are some retry attempts left
                                uShared._failedRequests++;
                                uShared._ajax(options);
                            } else { // no retry attempts left, call error callback
                                error(xhr);
                            }
                        }*/
                    };

                // encode object into query string
                if (method === 'POST') {
                    encodedData = uShared._encodePOST(data);
                }

                // send data
                if ('XDomainRequest' in win) { // IE cross-domain request
                    xhr = new XDomainRequest();
                    xhr.onprogress = function () {};
                    xhr.onload = function () {
                        success(xhr.responseText);
                    };
                    xhr.onerror = function () {
                        retryOnError();
                    };
                } else if ('XMLHttpRequest' in win) { // standard cross-domain request
                    xhr = new XMLHttpRequest();
                    xhr.onreadystatechange = function () {
                        if (xhr.readyState === 4) {
                            if (xhr.status === 200) { // success
                                uShared._failedRequests = 0;
                                success(xhr.responseText);
                            } else {
                                retryOnError();
                            }
                        }
                    };
                } else {
                    uShared._uConsole.error('uDash: no asynchronous transport method available');
                }

                xhr._uibRequest = true; // mark request as UiB internal in order to not record it

                try {
                    xhr.open(method, url);
                    if (method === 'POST') {
                        if (xhr instanceof XMLHttpRequest) {
                            xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
                        }
                        // XDomainRequest accepts only text/plain as a content type
                        xhr.send(encodedData);
                    } else {
                        xhr.send();
                    }

                } catch (e) {
                    error(xhr);
                }

                return xhr;

            },

            __getElementByPath: function (targetPath) {

                var parent = document.getElementsByTagName("body")[0]; // start with a body
                var lastParent = parent;

                if (targetPath.indexOf('#') > -1) {
                    var targetId = targetPath.split('#')[1];


                    if (targetId.indexOf('/') > -1) {
                        targetId = targetId.split('/')[0];
                        targetPath = targetPath.substr(targetPath.indexOf("/") + 1, targetPath.length);
                    }
                    if (targetId.indexOf('.') > -1) {
                        targetId = targetId.split('.')[0];
                    }

                    parent = window.document.getElementById(targetId); // but if there's element with ID, start from the element with ID.
                }

                targetPath = targetPath.split("/");
                if (targetPath.length > 0) {
                    for (var i = 0; i < targetPath.length; i++) {

                        var element = targetPath[i].split("[")

                        if (element[1] == null) {
                            element[1] = 0; // if there's just one tag in element, it has no index
                        } else {
                            element[1] = element[1].split("]")[0] * 1 - 1;
                        }
                        if (element[0].indexOf('.') > 0) {
                            var tempE = element[0].split('.');
                            element[0] = tempE.shift()
                            element.push(tempE.join('.'));
                        }

                        if (parent) {
                            lastParent = parent;
                            parent = parent.children[element[1]];
                        }
                    }
                }
                return parent;
            },

            _getDomain: function () {
                if (uShared.domain) return uShared.domain;

                var i = 0,
                    domain = document.domain,
                    p = domain.split('.'),
                    s = '_gd' + (new Date()).getTime();
                while (i < (p.length - 1) && document.cookie.indexOf(s + '=' + s) == -1) {
                    domain = p.slice(-1 - (++i)).join('.');
                    document.cookie = s + "=" + s + ";domain=" + domain + ";";
                }
                document.cookie = s + "=;expires=Thu, 01 Jan 1970 00:00:01 GMT;domain=" + domain + ";";
                uShared.domain = domain;
                return domain;
            },

            // domain
            _domainChanged: function (url, cUrl) {
                var urlArr = url.split('/');
                if (!cUrl) cUrl = uShared._sstorage.get('currentUrl');
                if (cUrl) {
                    var currentUrlArr = cUrl.split('/');
                    uShared._sstorage.set('currentUrl', win.location.href);
                    if (urlArr[2] != currentUrlArr[2] || urlArr[0] != currentUrlArr[0]) {
                        return true
                    }
                }
                return false;
            },

            // set cookie

            _setCookie: function (name, value, expires) {

                if (!win.uDash._globalSettings.uAllowCookies) {
                    uShared._unsavedCookies[name] = {
                        "name": name,
                        "value": value,
                        "expires": expires
                    };
                    return;
                }

                if (!expires) {
                    expires = new Date();
                    expires.setTime(expires.getTime() + (365 * 24 * 60 * 60 * 1000));
                }
                if (typeof value !== 'string') {
                    value = JSON.stringify(value);
                }
                win.document.cookie = name + '=' + escape(value) + '; domain=' + uShared._getDomain() + '; path=/; expires=' + expires.toGMTString() + ';';
            },
            _clearCookie: function (name) {
                win.document.cookie = name + '=""; domain=' + uShared._getDomain() + '; path=/; expires=Thu, 01 Jan 1970 00:00:01 GMT';
            },
            // read cookie
            _readCookie: function (name) {

                if (win.uDash._globalSettings && !win.uDash._globalSettings.uAllowCookies) {
                    return uShared._unsavedCookies[name];
                }
                var nameEQ = name + "=";
                var ca = document.cookie.split(';');
                for (var i = 0; i < ca.length; i++) {
                    var c = ca[i];
                    while (c.charAt(0) == ' ') c = c.substring(1, c.length);
                    if (c.indexOf(nameEQ) == 0) return unescape(c.substring(nameEQ.length, c.length));
                }
                return null;
            }

        };

        // localStorage init
        uShared._lstorage = new uShared._UStorage(win.localStorage);

        // sessionStorage init
        uShared._sstorage = new uShared._UStorage(win.sessionStorage);



        return uShared;

    }(window));

    return uShared;
});



//////////////////
// WEBPACK FOOTER
// ./ushared.js
// module id = 1
// module chunks = 0